<template>
  <div ref="stickyelement1">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    desktopOffset: {
      type: Number,
      default: 101
    },
    mobileOffset: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      stickyTop: 0,
      stickyoffset: 0,

    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    const el = this.$refs["stickyelement1"];
    this.stickyTop = (this.$isDesktop() ? this.desktopOffset : this.mobileOffset);
    this.stickyoffset = el.getBoundingClientRect().top - this.stickyTop;
    // console.log(this.stickyoffset);
    el.style.left = el.offsetLeft + "px";
    el.style.width = el.clientWidth + "px";
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const stickyelement = this.$refs["stickyelement1"];
    //   console.log(window.pageYOffset);
    //   console.log(this.stickyoffset);
    //   console.log('---');
      if (window.pageYOffset >= this.stickyoffset) {
        stickyelement.classList.add("stickyElement");
        stickyelement.style.cssText = "top:" + this.stickyTop + "px;";
      } else {
        stickyelement.classList.remove("stickyElement");
        stickyelement.style.cssText = "";
      }
    },
  }
}
</script>
<style scoped>

</style>